import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GTMTracking, Modal } from '@common/ui/general';
import { useMediaQuery } from '@common/hooks';

import FilterRecommendation from '@vectord/filter-recommendation';

import { getData, setData } from '@alumni_v2/utils/browserData';
import { isUserLoggedIn } from '@alumni_v2/utils/helpers';
import { gtmEventHandler } from '@common/utils/gtm';

import {
  updateRequestParams,
  setIsPersonalisationModalOpen,
} from '@alumni_v2/stores/reviews/actions';
import {
  personalisedModalSelector,
} from '@alumni_v2/selectors/reviews';
import UserCirclePlus from '@alumni_v2/images/svg/user-circle-plus.svg';

import styles from './FilterRecommendationButton.module.scss';


const PERSONALISATION_COOKIE_KEY = 'isPersonalisationFilterUsed';

const FilterRecommendationButton = () => {
  const { tablet } = useMediaQuery();
  const isPersonalisationFilterUsed = getData(PERSONALISATION_COOKIE_KEY);
  const dispatch = useDispatch();
  const personalisationModalSessionStorage = sessionStorage.getItem(
    'personalisation-modal-open',
  ) === 'true';

  const [shouldOpenPersonalisation, setShouldOpenPersonalisation] = useState(
    personalisationModalSessionStorage,
  );
  const {
    isPersonalisedModalOpen,
  } = useSelector(personalisedModalSelector);


  const onFilterRecommendationClick = useCallback((selectedOptionsQuery) => {
    dispatch(
      updateRequestParams(
        [], selectedOptionsQuery, null,
      ),
    );
    setData(PERSONALISATION_COOKIE_KEY, true);
    sessionStorage.setItem('personalisation-modal-open', true);
    setTimeout(() => {
      dispatch(setIsPersonalisationModalOpen(false));
    }, 3000);
  }, [dispatch]);

  const handlePersonalisedModal = useCallback((value) => {
    sessionStorage.setItem('personalisation-modal-open', true);
    dispatch(setIsPersonalisationModalOpen(value));
  }, [dispatch]);

  const handleMatchingProfile = useCallback((value) => {
    setShouldOpenPersonalisation(false);
    gtmEventHandler(
      'cta',
      'personlisation_modal_close',
      'click',
      'alumni_directory',
    );
    dispatch(setIsPersonalisationModalOpen(value));
  }, [dispatch]);

  useEffect(() => {
    dispatch(setIsPersonalisationModalOpen(
      !isPersonalisationFilterUsed && !personalisationModalSessionStorage,
    ));
  }, [
    dispatch, isPersonalisationFilterUsed, personalisationModalSessionStorage,
  ]);

  return (
    <>
      <GTMTracking
        className={styles.filterRecommendation}
        component="button"
        type="button"
        onClick={() => handleMatchingProfile(true)}
        gtmEventType="cta"
        gtmEventAction="click"
        gtmEventResult="personalised_modal_button"
        gtmEventCategory="alumni_directory"
        gtmEventData={{
          click_type: 'personalised_modal_button',
        }}
      >
        <img src={UserCirclePlus} alt="user-circle-plus" />
        Find Matching Profiles
      </GTMTracking>
      {
        !shouldOpenPersonalisation ? (
          <Modal
            isOpen={isPersonalisedModalOpen}
            onClose={() => handlePersonalisedModal(false)}
            position={tablet ? 'bottom' : 'center'}
            className={styles.modalContainerUi}
            containerClassName={styles.bodyUi}
            withoutHeader
            canClose
            hasCloseButton
          >
            {isPersonalisedModalOpen ? (
              <div className="scaler">
                <FilterRecommendation
                  onFilterRecommendationClick={onFilterRecommendationClick}
                  userId={isUserLoggedIn() ?? ''}
                />
              </div>
            ) : null}
          </Modal>
        ) : null
      }
    </>
  );
};

export default FilterRecommendationButton;
